export function addCurrent(retrain) {
    return {
        type: 'ADD_CURRENT_RETRAIN',
        retrain,
    }
}
